import React, { useState, useEffect } from 'react';
import Select from 'react-select';
import { Column, Table } from 'react-virtualized';
import InfiniteList from './InfiniteList';
import _ from 'lodash';
import Api from './Config';

const NONE = 'NONE';
const ADD = 'ADD';
const EDIT = 'EDIT';

export default (props) => {
  const [apps, setApps] = useState([]);
  const [selectedApps, setSelectedApps] = useState([]);
  const [clusterName, setClusterName] = useState('');
  const [clusters, setClusters] = useState([]);
  const [formMode, setFormMode] = useState('NONE');
  const [id, setId] = useState(null);
  const [reloadList, setReloadList] = useState(0);

  useEffect(() => {
    Api.getApps().then((apps) => {
      let allApps = _.map(apps, (a) => {
        a.clubname = unescape(a.clubname);
        return a;
      });
      allApps = _.orderBy(allApps, ['clubname']);
      setApps(allApps);
    });
  }, []);

  const loadRows = async (startIdx, queryAmount) => {
    const results = await Api.getClusters(startIdx, queryAmount);
    let newClusters = results.data;
    if (startIdx > 0) {
      newClusters = clusters.concat(newClusters);
    }
    setClusters(newClusters);

    return {
      data: results.data,
      maxRows: results.maxRows,
    };
  };

  const itemSelected = (values) => {
    setSelectedApps(values);
  };

  const doEdit = (cluster) => {
    doReset();
    setFormMode(EDIT);
    setId(cluster.id);
    setClusterName(cluster.cluster_name);
    const appCodes = cluster.apps.map((a) => a.app_code);
    const selected = _.filter(apps, (a) => appCodes.includes(a.club_id));

    setSelectedApps(selected);
  };

  const doReset = () => {
    setSelectedApps([]);
    setClusterName('');
    setId(null);
  };

  const doSave = () => {
    if (clusterName.trim().length < 1) {
      alert('Cluster name required!');
      return;
    }

    if (selectedApps == null || selectedApps.length < 1) {
      alert('at least one app required for cluster');
      return;
    }

    Api.addCluster(clusterName, selectedApps, formMode, id)
      .then(() => {
        if (formMode == ADD) {
          alert('Cluster added successfully.');
        } else {
          alert('Cluster updated successfully.');
        }

        setReloadList(reloadList + 1);
        doReset();
        setFormMode(NONE);
      })
      .catch((err) => {
        alert('' + err);
      });
  };

  const deleteCluster = ({ id, cluster_name }) => {
    if (confirm('Are you sure you want to delete ' + cluster_name)) {
      Api.deleteCluster(id).then(() => {
        setClusters(clusters.filter((item) => item.id != id));
      });
    }
  };

  const getTableCell = ({ dataKey, rowData, rowIndex }) => {
    let cellItem;

    switch (dataKey) {
      case 'row_idx':
        cellItem = rowIndex + 1;
        break;
      case 'edit':
        cellItem = (
          <button
            onClick={() => {
              doEdit(rowData);
            }}
            className="btn btn-primary btn-sm"
          >
            Edit
          </button>
        );
        break;
      case 'delete':
        cellItem = (
          <button
            className="btn btn-danger btn-sm"
            onClick={() => {
              deleteCluster(rowData);
            }}
          >
            Delete
          </button>
        );
        break;
    }

    return cellItem;
  };

  return (
    <div>
      <div>
        <button
          className="btn btn-success"
          style={{ marginBottom: 20 }}
          onClick={() => {
            doReset();
            setFormMode(ADD);
          }}
          type="button"
        >
          Add New
        </button>
      </div>

      {formMode != NONE && (
        <div className="modal show ">
          <div className="modal-dialog">
            <div className="modal-content">
              <div className="modal-header">{formMode == EDIT ? 'Edit Cluster' : 'Add New Cluster'}</div>
              <div className="modal-body">
                <div className="form-group">
                  <label>Cluster Name</label>
                  <input
                    onChange={(e) => {
                      setClusterName(e.target.value);
                    }}
                    value={clusterName}
                    type="text"
                    className="form-control"
                  ></input>
                </div>
                <div className="form-group">
                  <label>Apps</label>
                  <Select
                    isMulti={true}
                    value={selectedApps}
                    onChange={itemSelected}
                    getOptionValue={(a) => a.club_id}
                    getOptionLabel={(a) => a.clubname}
                    options={apps}
                  />
                </div>
              </div>
              <div className="modal-footer">
                <button onClick={doSave} className="btn btn-primary">
                  {formMode == ADD ? 'Add New' : 'Save Changes'}
                </button>
                <button
                  onClick={() => {
                    doReset();
                    setFormMode(NONE);
                  }}
                  className="btn btn-info"
                >
                  Cancel
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
      <InfiniteList lists={clusters} loadRows={loadRows} reloadList={reloadList}>
        {({ onRowsRendered, registerChild, width }) => (
          <Table
            ref={registerChild}
            onRowsRendered={onRowsRendered}
            width={width}
            height={800}
            headerHeight={40}
            rowStyle={{
              borderBottom: '1px solid #ddd',
              paddingTop: 5,
              paddingBottom: 5,
            }}
            rowHeight={40}
            rowCount={clusters.length}
            rowGetter={({ index }) => clusters[index]}
          >
            <Column label="#" dataKey="row_idx" cellRenderer={getTableCell} width={50} />
            <Column label="Cluster name" dataKey="cluster_name" width={width / 1.5} />
            <Column label="Edit" dataKey="edit" cellRenderer={getTableCell} width={150} />
            <Column label="Delete" dataKey="delete" cellRenderer={getTableCell} width={150} />
          </Table>
        )}
      </InfiniteList>
    </div>
  );
};
